// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PjP3","title":"styles_title__1CS6a"};